import { Heading, Image, Paragraph } from '@zillow/constellation-10';
import { useLeaseQuery } from '../../../utils/queries';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';
import Handshake from '../../../../../images/handshake.svg';

export default function YourUpcomingLeaseTermWillBeMonthToMonth() {
  const { leaseId } = useLeasingUrlParams();

  const leaseQuery = useLeaseQuery(leaseId);

  const lease = leaseQuery?.data;
  const endDate = lease?.getLeasePackageFriendlyEndDate();

  return (
    <>
      <Image src={Handshake} alt="two hands shaking" css={{ height: '160px', width: '160px', marginBottom: 'loose' }} />
      <Heading
        level={2}
        css={{
          textStyle:
            'responsive.heading-md' /* oxlint-disable-line constellation/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
          marginBottom: 'loose',
        }}
      >
        Your upcoming lease term will be month-to-month
      </Heading>
      {endDate ? (
        <Paragraph>
          After your lease term ends on <strong>{endDate}</strong>, your next term will automatically convert to
          month-to-month unless you end the lease.
        </Paragraph>
      ) : (
        <Paragraph>
          After your lease term ends, your next term will automatically convert to month-to-month unless you end the
          lease.
        </Paragraph>
      )}
    </>
  );
}
